import { EDIT_CLIENT } from 'constants/actionTypes';

export function editClient(cl) {
  return {
    type: EDIT_CLIENT,
    cl,
  };
}
